import React, { useState } from 'react';

import { Modal, Header, Body, Footer, FooterButton } from './modalElements';
import { ModalContent } from './styles';

export default React.memo((props) => {
  const [isOpen, setIsOpen] = useState(true);

  const confirmModal = (value) => {
    setIsOpen(false);
    return props.confirm(value);
  };

  return (
    <Modal isOpen={isOpen}>
      <Header>{props.modalInfo.title}</Header>
      <Body>
        <ModalContent
          dangerouslySetInnerHTML={{
            __html: props.modalInfo.body,
          }}
        ></ModalContent>
      </Body>
      <Footer>
        <FooterButton label="Yes" onClick={() => confirmModal(true)} />
        <FooterButton label="No" onClick={() => confirmModal(false)} autoFocus />
      </Footer>
    </Modal>
  );
});
